import { postRequest } from '@/core';
import { tripAddresses } from '@/requests';

export default async function newTripAddressRequest(locationData) {
	let url = tripAddresses.getPath();
	let response = await postRequest(url, {}, locationData);
	return response;
}
